var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCloseSideBar = function SvgCloseSideBar(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_881_1466",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_881_1466)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.62346 12.9888V7.01131L6.62669 10.0001L9.62346 12.9888ZM4.42316 17.0834C4.00757 17.0834 3.6526 16.9362 3.35827 16.6419C3.06392 16.3475 2.91675 15.9926 2.91675 15.577V4.42317C2.91675 4.00757 3.06392 3.6526 3.35827 3.35827C3.6526 3.06392 4.00757 2.91675 4.42316 2.91675H15.577C15.9926 2.91675 16.3475 3.06392 16.6419 3.35827C16.9362 3.6526 17.0834 4.00757 17.0834 4.42317V15.577C17.0834 15.9926 16.9362 16.3475 16.6419 16.6419C16.3475 16.9362 15.9926 17.0834 15.577 17.0834H4.42316ZM12.0834 15.8334V4.16673H4.42316C4.35905 4.16673 4.30028 4.19344 4.24685 4.24685C4.19344 4.30028 4.16673 4.35905 4.16673 4.42317V15.577C4.16673 15.6411 4.19344 15.6998 4.24685 15.7533C4.30028 15.8067 4.35905 15.8334 4.42316 15.8334H12.0834Z",
    fill: "#B6BDC7"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCloseSideBar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "closeSideBar.bf947c6380b8c66ef2542e906aa2fcb6.svg";